/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * provide an action to the server for how to deal with this record. The action will be controlled by business rules and not always available depending on the status of the record.
 */
export enum UpdateAction {
	REMOVE = 'Remove',
	UPDATE = 'Update',
	CREATE = 'Create',
	NONE = 'None',
}
